/**
 * Skeleton — subtle animated placeholder for loading states.
 * Use `<Skeleton className="h-4 w-32" />` etc.
 */
export function Skeleton({ className = "" }) {
  return <div className={`sp-skeleton rounded ${className}`} />;
}

// Common composed skeletons
export const SkeletonLine = ({ w = "w-full", h = "h-4" }) => <Skeleton className={`${w} ${h}`} />;

export const SkeletonCard = ({ h = "h-24" }) => (
  <div className={`sp-card p-5 space-y-2`}>
    <SkeletonLine w="w-24" h="h-3" />
    <SkeletonLine w="w-32" h="h-8" />
    <SkeletonLine w="w-40" h="h-2" />
  </div>
);
